'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.firstValArg = exports.createObj = undefined;

var _zipObject2 = require('lodash/zipObject');

var _zipObject3 = _interopRequireDefault(_zipObject2);

var _spread2 = require('lodash/spread');

var _spread3 = _interopRequireDefault(_spread2);

var _partial2 = require('lodash/partial');

var _partial3 = _interopRequireDefault(_partial2);

var _nthArg2 = require('lodash/nthArg');

var _nthArg3 = _interopRequireDefault(_nthArg2);

var _includes2 = require('lodash/includes');

var _includes3 = _interopRequireDefault(_includes2);

var _flow2 = require('lodash/flow');

var _flow3 = _interopRequireDefault(_flow2);

var _find2 = require('lodash/find');

var _find3 = _interopRequireDefault(_find2);

var _fill2 = require('lodash/fill');

var _fill3 = _interopRequireDefault(_fill2);

var _defaultTo2 = require('lodash/defaultTo');

var _defaultTo3 = _interopRequireDefault(_defaultTo2);

var _curry2 = require('lodash/curry');

var _curry3 = _interopRequireDefault(_curry2);

exports.callWith = callWith;
exports.invokeArg = invokeArg;
exports.invokeNthArg = invokeNthArg;
exports.getDefault = getDefault;
exports.oneOf = oneOf;
exports.arrayTrueObj = arrayTrueObj;

var _at = require('lodash/fp/at');

var _at2 = _interopRequireDefault(_at);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var createObj = exports.createObj = (0, _curry3.default)(function (key, val) {
  return _defineProperty({}, key, val);
});

function callWith() {
  for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  return function (func) {
    return func.apply(undefined, args);
  };
}
function invokeArg(func) {
  return func();
}
function invokeNthArg(index) {
  return (0, _flow3.default)((0, _nthArg3.default)(index), invokeArg);
}

// Find the first truthy argument value, .
var firstValArg = exports.firstValArg = (0, _flow3.default)(Array, _find3.default);

// Given two paths, select the first one that is defined.
function getDefault(path1, path2) {
  return (0, _flow3.default)((0, _at2.default)([path1, path2]), (0, _spread3.default)(_defaultTo3.default));
}

function oneOf(list) {
  return (0, _partial3.default)(_includes3.default, list);
}

function arrayTrueObj(arr) {
  if (!arr || !arr.length) return {};
  return (0, _zipObject3.default)(arr, (0, _fill3.default)(Array(arr.length), true));
}


//////////////////
// WEBPACK FOOTER
// ./~/cape-lodash/lib/utils.js
// module id = 663
// module chunks = 0